import Common from "./modules/common";
import Header from "./modules/header";
import Search from "./modules/search";
import Instagram from "./modules/instagram";
import Budget from "./modules/budget";
import Mask from "./modules/mask";
import Gallery from "./modules/gallery";
import LightGallery from "./modules/lightgallery";

document.addEventListener("DOMContentLoaded", function (event) {
  console.log(
    "%cMade in BRZ Digital! \ud83d\ude42 We love to inspect codes too \ud83d\udc40",
    "font-size: 16px; color: #a7bf34"
  );
});

const availableModules = {
  Common,
  Header,
  Search,
  Instagram,
  Budget,
  Mask,
  Gallery,
  LightGallery,
};

window.modules = {};

$(() => {
  const htmlModules = $("[data-module]");

  // Loading htmlModules if they are in availableModules
  htmlModules.each((key, value) => {
    const mod = $(value).data("module");

    if (Object.prototype.hasOwnProperty.call(availableModules, mod)) {
      window.modules[mod] = new availableModules[mod]();
    } else {
      console.log(`The module "${mod}" does not exists.`);
    }
  });
});

$.fn.serializeObject = function () {
  var o = {};
  var a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || "");
    } else {
      o[this.name] = this.value || "";
    }
  });
  return o;
};

$.fn.existsWithValue = function () {
  return this.length && this.val().length;
};
